<template>
    <article class="product-list-item card" @mouseover="hoverActive = true" @mouseleave="hoverActive = false">
        <div class="card-body">
            <div :class="paddingClasses" :style="paddingInlineStyles">
                <div class="product-image-wrapper">
                    <a :href="item | itemURL(urlWithVariationId)">
                        <img v-if="!hoverActive  || isMobile" class="product-image"
                             :src="item.images.all[0].urlMiddle"
                             :alt="item.texts.name1"
                             :title="item.texts.name1">

                        <img v-else class="product-image"
                             :src="item.images.all[1].urlMiddle"
                             :alt="item.texts.name1"
                             :title="item.texts.name1">

                    </a>
                </div>

                <slot name="store-special">
                    <item-store-special
                            v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                            :store-special="storeSpecial"
                            :recommended-retail-price="item.prices.rrp"
                            :variation-retail-price="item.prices.default"
                            :special-offer-price="item.prices.specialOffer"
                            :decimal-count="decimalCount"
                            :bundle-type="item.variation.bundleType"
                            :item-type="item.item.itemType">
                    </item-store-special>
                </slot>

                <!-- ITEM DETAILS -->
                <slot name="item-details">
                    <div class="product-info">
                        <a :href="item | itemURL(urlWithVariationId)" class="product-name">
                            {{ item | itemName }}<!--
                        --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                        </a>

                        <div class="product-color">{{ getColor }}</div>

                        <slot name="before-prices"></slot>

                        <div class="product-price" v-if="item.item.salableVariationCount"
                             :class="{'product-price--sale': item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value}">
                            <template v-if="item.item.itemType === 'set'">
                                {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}*
                            </template>
<!--                            <template-->
<!--                                    v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting">-->
<!--                                {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }}*-->
<!--                            </template>-->
                            <template v-else>
                                {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice",
                                "formatted") }}*
                            </template>

                            <template
                                    v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value">
                                <span class="product-price--uvp" v-if="item.prices.specialOffer">
                                    {{ item.prices.default.unitPrice.formatted}}
                                </span>
                                <span class="product-price--uvp" v-else>
                                    {{ item.prices.rrp.unitPrice.formatted }}
                                </span>
                            </template>

                        </div>

                        <div class="product-price" v-else>
                            {{ $translate('FLGNTLT::Template.soldout') }}
                        </div>

                        <slot name="after-prices"></slot>

                        <transition name="slide-fade" v-if="!isMobile && item.variations && item.attributeMap">
                            <div class="product-variation-matrix-wrapper" v-if="item.item.salableVariationCount" v-show="hoverActive">
                                <variation-matrix :variation-data="item.variations" :attribute-data="item.attributeMap"></variation-matrix>
                            </div>
                        </transition>
                    </div>

                </slot>
                <!-- ./ITEM DETAILS  -->
            </div>
        </div>
    </article>
</template>

<script>
    import {mapState} from "vuex";
    import ItemStoreSpecial from "~/app/components/itemList/ItemStoreSpecial.vue";
	import {getSlotData} from "ceres/app/helper/getSlotData";

    export default {
        components: {
            ItemStoreSpecial
        },

        props: {
            decimalCount:
                {
                    type: Number,
                    default: 0
                },
            imageUrlAccessor:
                {
                    type: String,
                    default: "urlMiddle"
                },
            itemData:
                {
                    type: Object
                },
            disableCarouselOnMobile:
                {
                    type: Boolean
                },
            paddingClasses:
                {
                    type: String,
                    default: null
                },
            paddingInlineStyles:
            {
                type: String,
                default: null
            },
            forceUrlWithVariationId:
            {
                type: Boolean,
                default: false
            }
        },

        jsonDataFields: [
            "itemDataRef"
        ],

        data() {
            return {
                hoverActive: false,
                isMobile: true
            }
        },

        mounted(){
            this.isMobile = window.innerWidth < 1200;
        },

        computed:
            {

                getColor() {
                    let returnVal;

                    for (let key in this.item.variationProperties) {
                        for (let key2 in this.item.variationProperties[key].properties) {
                            if (this.item.variationProperties[key].properties[key2].id === 1) {
                                returnVal = this.item.variationProperties[key].properties[key2].values.value
                            }
                        }
                    }

                    return returnVal
                },

                item() {
					return this.itemData || this.itemSlotData || this.itemDataRef;
                },
				itemSlotData: getSlotData('item-data'),

                /**
                 * returns itemData.item.storeSpecial
                 */
                storeSpecial() {
                    return this.item.item.storeSpecial;
                },

                /**
                 * returns itemData.texts
                 */
                texts() {
                    return this.item.texts;
                },

				basePrice()
				{
					return this.item.prices.graduatedPrices.length > 0
						? this.item.prices.graduatedPrices[0].basePrice
						: this.item.prices.default.basePrice;
				},

				itemPriceGraduated()
				{
					let unitPrice = this.item.prices.graduatedPrices.length > 0
						? this.item.prices.graduatedPrices[0].unitPrice
						: this.item.prices.default.unitPrice;
					return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
				},

				itemGraduatedPriceisCheapestSorting()
				{
					return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
				},

				itemGraduatedPricesalableVariationCount()
				{
					return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1;
				},

                itemPrice() {
                    return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
                },

                itemSetPrice() {
                    return this.$options.filters.currency(
                        this.item.prices.default.price.value,
                        this.item.prices.default.currency
                    );
                },

                urlWithVariationId() {
                    return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0;
                },

                ...mapState({
                    showNetPrices: state => state.basket.showNetPrices
                })
            }
    }
</script>
